/**
 * As legal requirements, the whole block of text with inline disclaimer need to be clickable,
 * not just the disclaimer itself. Thus this component needs to wrap around the text to provide
 * the onClick event to the whole block of text + disclaimer.
 */

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRadium, DetectCompact } from 'higher-order-components'
import { ToastPopup } from 'containers'
import { HAS_TOUCH } from 'constants/environment'
import { invokeFuncs } from 'utils/function'

class InlineDisclaimerBlock extends PureComponent {
  constructor(props) {
    super()
    this.state = {
      open: false,
      fresh: 0
    }
  }
  static defaultProps = {
    identifier: '*',
    isIdentifierHidden: false,
    showingUnderline: false
  }
  static propTypes = {
    message: PropTypes.string,
    identifier: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    yOffset: PropTypes.number,
    gtmEvents: PropTypes.array,
    blockStyling: PropTypes.object,
    disclaimerStyling: PropTypes.object,
    isIdentifierHidden: PropTypes.bool,
    showingUnderline: PropTypes.bool,
    isIdentifierHiddenInPopUp: PropTypes.bool
  }
  componentWillUnmount() {
    this.setState({ open: false, fresh: this.state.fresh + 1 })
  }
  handleClick = e => {
    if (!this.props.message || this.state.open) return
    const { gtmEvents } = this.props
    e.stopPropagation()
    gtmEvents && invokeFuncs(gtmEvents)
    this.setState({ open: true, fresh: this.state.fresh + 1 })
  }
  /**
   * @param {string} message - Disclaimer message to display on click.
   * @param {string} identifier - Character or number to insert. Defaults to *.
   * @param {number} yOffset - Vertical position offset (used to avoid conflict with sticky elements).
   * @param {array} gtmEvents - Actions array fired on click.
   * @param {object} blockStyling - Styling of the whole block (text + disclaimer)
   * @param {object} disclaimerStyling - Any customised styling for the disclaimer
   * @returns {ReactElement} React Component
   */
  render() {
    const {
      yOffset,
      blockStyling,
      disclaimerStyling,
      identifier,
      children,
      message,
      showingUnderline,
      isIdentifierHidden
    } = this.props
    return (
      <div
        style={[
          blockStyling,
          {
            cursor: message && 'pointer',
            ':hover': showingUnderline &&
              !HAS_TOUCH &&
              message && {
                textDecoration: 'underline'
              }
          }
        ]}
        data-test={`inline-version-rendered-${this.state.fresh}`}
        onClick={this.handleClick}>
        {children}
        {message && (
          <div data-test="inline-disclaimer" style={{ display: !isIdentifierHidden && 'inline' }}>
            <sup
              key={'sup'}
              style={[
                styles.priceDisclaimer,
                { ...disclaimerStyling },
                isIdentifierHidden && { display: 'none' }
              ]}>
              {identifier}
            </sup>
            {this.state.open && (
              <ToastPopup
                show={this.state.open}
                yOffset={yOffset}
                onCloseClick={() => {
                  this.setState({ open: false })
                }}>
                {this.props.identifier &&
                  !this.props.isIdentifierHiddenInPopUp && (
                    <div style={styles.identifier}>{identifier}</div>
                  )}
                <p style={styles.message}>{message}</p>
              </ToastPopup>
            )}
          </div>
        )}
      </div>
    )
  }
}

export default withRadium(DetectCompact())(InlineDisclaimerBlock)

const styles = {
  identifier: {
    fontSize: '300%',
    paddingRight: '.5em'
  },
  message: {
    lineHeight: 1.4
  },
  priceDisclaimer: {
    fontWeight: 400,
    position: 'relative',
    top: '0.1em',
    fontSize: '85%',
    lineHeight: 0,
    marginLeft: '.2em',
    textDecoration: HAS_TOUCH ? 'underline' : 'none',
    color: '#910A2D',
    ':hover': !HAS_TOUCH && {
      textDecoration: 'underline'
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/inline-disclaimer-block/index.jsx